module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "questionnaire-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [(_vm.question) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, [_c('p', [_vm._v(_vm._s(_vm.question.question))])]), _c('div', {
    staticClass: "answers"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('button', {
      staticClass: "button answer is-large is-light",
      class: _vm.asnwerRevealedClass(answer),
      on: {
        "click": function($event) {
          _vm.reply(answer)
        }
      }
    }, [_vm._v(_vm._s(answer.text))])
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e4a4003"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/task/QuestionnairePage.vue
// module id = 428
// module chunks = 0